/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import t from "react";
const n = t.createContext([
  null,
  (e) => {
  }
]), a = t.createContext([
  null,
  (e) => {
  }
]), s = t.createContext([
  null,
  (e) => {
  }
]);
export {
  s as ChipListDataContext,
  a as ChipListFocusContext,
  n as ChipListSelectionContext
};
